<template>
  <div class="main-container">
    <div style="width: 100%;">
      <el-input
        style="max-width: 200px;"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
    <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;">
        <h2 style="flex: 1;">Transaction History </h2>
    
      
      </div>

      <div
       
      >
        <vue-good-table
          :columns="cxTeamFields"
          :rows="getUsersAdmin"
          :search-options="{ enabled: true, externalQuery: searchTerm }"
          :pagination-options="{ enabled: true }"
        >
          <template
            slot="table-row"
            slot-scope="props"
            style="background: red;"
          >
            <!-- {{1}} -->
            <span v-if="props.column.field == 'full_name'"
              >{{ props.row.firstname }} {{ props.row.lastname }}</span
            >
            <span v-if="props.column.field == 'gender'">
              {{ props.row.gender + "" === "0" ? "Female" : "Male" }}
            </span>
            <span v-if="props.column.field == 'actions'">
              <router-link :to="`priviledges/${props.row.id}`" @click="pressFunc">
                <button class="btn btn-md btn-success">
                  Pay Now &nbsp;
                  <span class="fa fa-wrench"></span>
                </button>
              </router-link>
            
            </span>
            <span v-else>{{ props.row[props.column.field] }}</span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_"),
});

const items = [];
export default {
  // components: {
  //   Inventory
  // },
  data() {
    return {
      searchTerm: "",
      usertype: localStorage.roleType,
      selectOption: {
        enabled: true,
      },
      items: items,
      fields: [
        {
          field: "id",
          label: "ID",
          sortable: "true",
        },
        {
          field: "full_name",
          label: "Full Name",
          sortable: "true",
        },
        {
          field: "roleType",
          label: "User Type",
          sortable: "true",
        },
        {
          field: "email",
          label: "E-mail",
          sortable: "true",
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: "gender",
          label: "Gender",
          sortable: "true",
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: "phoneNumber",
          label: "Phone Number",
          sortable: "true",
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: "updatedAt",
          label: "Last Seen",
          sortable: "true",
        },
          {
          field: "actions",
          label: "Actions",
        },
      ],
      cxTeamFields: [
        {
          field: "id",
          label: "ID",
          sortable: "true",
        },
        {
          field: "full_name",
          label: "Full Name",
          sortable: "true",
        },
        {
          field: "roletype",
          label: "User Type",
          sortable: "true",
        },
        {
          field: "email",
          label: "E-mail",
          sortable: "true",
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: "gender",
          label: "Gender",
          sortable: "true",
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: "phonenumber",
          label: "Phone Number",
          sortable: "true",
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: "updatedat",
          label: "Last Seen",
          sortable: "true",
        },
        {
          field: "actions",
          label: "Actions",
        },
      ],
       cxTeamFieldsAdmin: [
        {
          field: "id",
          label: "ID",
          sortable: "true",
        },
        {
          field: "full_name",
          label: "Full Name",
          sortable: "true",
        },
        {
          field: "roleType",
          label: "User Type",
          sortable: "true",
        },
        {
          field: "email",
          label: "E-mail",
          sortable: "true",
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: "gender",
          label: "Gender",
          sortable: "true",
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: "phoneNumber",
          label: "Phone Number",
          sortable: "true",
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: "updatedAt",
          label: "Last Seen",
          sortable: "true",
        },
        {
          field: "actions",
          label: "Actions",
        },
      ],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: "",
      },
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getUsersAdmin",
      "getDummy",
      "getDevices",
    ]),
    isACxTeam: {
      get() {
        if (this.$can("am", "cxTeam") || this.$can("edit", "user")) {
          return true;
        } else {
          return true;
        }
      },
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return {
            text: f.label,
            value: f.key,
          };
        });
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user,
        },
      });
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    pressFunc(){
      console.log('i was presseed')

    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url = `/users?filter[include][installations]=deviceType&filter[where][roleType][neq]=CUSTOMER`+`&filter[order]=id DESC`;
      HTTP.get(url)
        .then((response) => {
          const usersList = response.data;
          this.$store.commit("saveUsers", usersList);
          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    fetchUsersAdmin() {
      const HTTP = this.$httpUtils.instance;
      let data = new FormData();
      let id = localStorage.customerId;
      data.append("customerAdminUserId", id);
      //  filter={"include": ["installations"]}
      const url = `/groupUsers/getUsersByCustomerAdmin`;
      HTTP.post(url, data)
        .then((response) => {
          const usersList = response.data;
          this.$store.commit("saveUsersAdmin", usersList);
          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
  mounted() {
    this.fetchUsersAdmin();
    this.fetchUsers();
    // console.log(this.getDummy)
  },
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/payment/transaction_history.vue